import MobileEditorConnected from './MobileEditorConnected'

export default MobileEditorConnected
